import { useHttp } from "../http-hook/http.hook";
import { API_URL } from "../helpers";

const removeEmptyValues = (obj) => {
  if (typeof obj !== "object" || obj === null) return obj;

  const result = Array.isArray(obj) ? [] : {};

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    if (value !== null && value !== undefined && value !== "") {
      result[key] =
        typeof value === "object" ? removeEmptyValues(value) : value;
    }
  });

  return result;
};

const useLoadService = () => {
  const { request } = useHttp();

  const searchLoads = (vin) => {
    return request(`${API_URL}/loads?vin=${vin}`)
      .then((res) => res)
      .catch((e) => {
        throw new Error(e?.message || "Failed to search loads");
      });
  };

  const createLoad = (loadData, images, carrierImageFile, newBOL) => {
    const cleanedData = removeEmptyValues(loadData);
    const formData = new FormData();
    formData.append("data", JSON.stringify(cleanedData));

    images &&
      images.forEach((file) => {
        formData.append("images", file);
      });

    carrierImageFile &&
      carrierImageFile.forEach((file) => {
        formData.append("carrierImageFile", file);
      });

    newBOL &&
      newBOL.forEach((file) => {
        formData.append("BOL", file); // BOL файлы (pdf/images)
      });

    return request(`${API_URL}/loads`, "POST", formData, {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    })
      .then((res) => res)
      .catch((e) => {
        throw new Error(e?.message || "Failed to create load");
      });
  };

  const getAllLoads = (page = 1, limit = 10, companyName = "cierta") => {
    return request(
      `${API_URL}/loads/all?page=${page}&limit=${limit}&companyName=${companyName}`,
      "GET"
    )
      .then((res) => res)
      .catch((e) => {
        throw new Error(e?.message || "Failed to get all loads");
      });
  };

  // Поддерживает images, carrierImageFile, newBOL и удалённые списки (включая removedBOL)
  const updateLoad = (
    updates,
    images = [],
    carrierImageFile = [],
    removedVehicleImages = [],
    removedCarrierImages = [],
    newBOL = [],
    removedBOL = []
  ) => {
    const cleanedData = removeEmptyValues({
      ...updates,
      removedVehicleImages,
      removedCarrierImages,
      removedBOL, // важно: передаём на сервер для удаления BOL
    });

    const formData = new FormData();
    formData.append("data", JSON.stringify(cleanedData));

    images &&
      images.forEach((file) => {
        formData.append("images", file);
      });

    carrierImageFile &&
      carrierImageFile.forEach((file) => {
        formData.append("carrierImageFile", file);
      });

    newBOL &&
      newBOL.forEach((file) => {
        formData.append("BOL", file);
      });

    return request(`${API_URL}/loads/${updates._id}`, "PUT", formData, {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    })
      .then((res) => res)
      .catch((e) => {
        throw new Error(e?.message || "Failed to update load");
      });
  };

  const deleteLoad = (id) => {
    return request(`${API_URL}/loads/${id}`, "DELETE", null, {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    })
      .then((res) => res)
      .catch((e) => {
        throw new Error(e?.message || "Failed to delete load");
      });
  };

  return { searchLoads, createLoad, updateLoad, deleteLoad, getAllLoads };
};

export default useLoadService;
